import styled from 'styled-components';

import { Nutrient } from './nutrient';

export const ContentWrapper = styled.div`
  width: 100%;

  & ${Nutrient}:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;
